import { useLocalStorage } from '@sortlist-frontend/utils';
import { useEffect } from 'react';

import { sessionTimeoutManager } from '../utils/SessionTimeoutManager';
import { useTrackingUuid } from './useTrackingUuid';

export { SESSION_TIMEOUT_MS } from '../utils/SessionTimeoutManager';
export const LAST_ACTIVITY_KEY = 'lastActivityTimestamp';

/**
 * Hook for tracking user activity and managing session timeouts
 * Uses a singleton SessionTimeoutManager to ensure only one timeout exists globally
 */
export function useTrackLastActivity() {
  const [lastActivity, setLastActivity] = useLocalStorage<string | null>(LAST_ACTIVITY_KEY, null);
  const { resetSessionUuid } = useTrackingUuid();

  // Register with the session timeout manager on mount
  useEffect(() => {
    // Set the reset callback in the manager
    sessionTimeoutManager.setResetSessionUuidCallback(resetSessionUuid);

    // Register this hook instance with the manager
    const unregister = sessionTimeoutManager.registerInstance();

    // Clean up on unmount
    return () => {
      unregister();
    };
  }, []);

  /**
   * Update the last activity timestamp and reset the global timeout
   */
  const updateLastActivity = () => {
    // Update the timestamp in localStorage
    setLastActivity(Date.now().toString());

    // Reset the global timeout
    sessionTimeoutManager.startTimeout();
  };

  return {
    // The last activity timestamp as a string
    lastActivity,
    // Function to update the last activity timestamp
    updateLastActivity,
  };
}
